import React from "react";

import { LiveNowListProps, LiveNowListState } from "./models";
import { Box, Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import { ContentEnduserService } from "services/content-enduser-service";

export class LiveNowList extends React.Component<LiveNowListProps, LiveNowListState> {

    constructor(props: any) {
        super(props);

        this.state = {
            liveNowContentList: [],
            loaded: false
        }
    }

    componentDidMount() {
        ContentEnduserService.getStartedOrStartingLiveContents(this.successCallback, this.errorCallback);
    }

    successCallback = (data: any) => {

        this.setState(() => ({ liveNowContentList: data.list, loaded: true }))

    }

    errorCallback = () => {

    }

    render() {
        return (<>
            {(this.state.loaded && this.state.liveNowContentList.length !== 0) && <>
                <Box className={"h-title"} textAlign={"center"} sx={{ mb: 2 }}>
                    <Typography variant={"h1"}
                        sx={{
                            color: "#FFFFFF",
                            fontWeight: "bold",
                            textTransform: "uppercase",
                        }}>
                        <Trans id="lnl-now-live-title">Ora in onda</Trans>
                    </Typography>
                </Box>
            </>}
        </>);
    }

}
